import { render, staticRenderFns } from "./SystemManage.vue?vue&type=template&id=553a8ae1"
import script from "./SystemManage.vue?vue&type=script&lang=js"
export * from "./SystemManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports